<template>
    <TableBase
        :cursorPointer="false"
        class="w-full mt-2.5"
    >
        <template #thead>
            <tr>
                <th class="px-4 py-2  w-1/4">
                    發卡機構
                </th>
                <th class="px-4 py-2  w-1/3">
                    卡號
                </th>
                <th class="px-4 py-2">
                    有效年月
                </th>
            </tr>
        </template>
        <template #tbody>
            <tr class="text-gray-900">
                <td class="px-4 pt-6 pb-3 align-top">
                    {{ data?.cardBankName }}
                </td>
                <td class="px-4 pt-6 pb-3 break-all align-top">
                    <p>
                        {{ data?.label }}
                    </p>
                </td>
                <td class=" px-4 py-3.5 align-top">
                    <slot />
                </td>
            </tr>
        </template>
    </TableBase>
</template>

<script>
import TableBase from '@/components/table/TableBase.vue';

export default {
    components: {
        TableBase,
    },
    props: {
        data: {
            type: Object,
            default: () => { }
        }
    },
    setup() {
    },
};
</script>
